import { generateUuid } from '../../../utils/uuids'

export type I18nLabel = {
  languageCode: string
  label: string
}
export type I18nLabelVO = {
  labelId: string
  labels: I18nLabel[]
}
export type I18nLabelObject = {
  labelId: string
  labels: I18nLabel[]
}

const DEFAULT_LANGUAGE_CODE = 'en'
/** VO service functions */
// Constructor
const construct = (): I18nLabelVO => {
  return {
    labelId: generateUuid(),
    labels: [],
  }
}
const copy = (src: I18nLabelVO): I18nLabelVO => {
  return structuredClone(src)
}
// Getters
const getCurrentLanguageCode = (): string => {
  return navigator.language.split(/[-_]/)[0]
}
const getLabel = (vo: I18nLabelVO): string => {
  const languageCode = navigator.language.split(/[-_]/)[0]
  const label = vo.labels.find(label => label.languageCode === languageCode)
  if (label) {
    return label.label
  }

  const labelEn = vo.labels.find(
    label => label.languageCode === DEFAULT_LANGUAGE_CODE
  )
  if (labelEn) {
    return labelEn.label
  }
  return ''
}
// Setters
const setCurrentLanguageLabel = (
  vo: I18nLabelVO,
  label: string
): I18nLabelVO => {
  const currentLanguageCode = getCurrentLanguageCode()
  return setLabel(vo, currentLanguageCode, label)
}
const setLabel = (
  vo: I18nLabelVO,
  languageCode: string,
  label: string
): I18nLabelVO => {
  const oldLabels = vo.labels
  const newLabels = oldLabels.map(v => {
    if (v.languageCode === languageCode) {
      return {
        ...v,
        label,
      }
    }
    return {
      ...v,
    }
  })
  return {
    labelId: vo.labelId,
    labels: newLabels,
  }
}
const setLabels = (vo: I18nLabelVO, labels: I18nLabel[]): I18nLabelVO => {
  return {
    labelId: vo.labelId,
    labels,
  }
}
const clearLabels = (vo: I18nLabelVO): I18nLabelVO => {
  return {
    labelId: vo.labelId,
    labels: [],
  }
}
// Others
const hasDiff = (a: I18nLabelVO, b: I18nLabelVO): boolean => {
  if (a.labelId !== b.labelId) {
    return true
  }
  const aLabels = a.labels
  const bLabels = b.labels
  return (
    aLabels.length !== bLabels.length ||
    aLabels.some(aLabel => {
      const bLabel = bLabels.find(v => v.languageCode === aLabel.languageCode)
      if (!bLabel) {
        return true
      }
      return aLabel.label !== bLabel.label
    })
  )
}

export const i18nLabelVoService = {
  construct,
  copy,
  getCurrentLanguageCode,
  getLabel,
  setCurrentLanguageLabel,
  setLabel,
  setLabels,
  clearLabels,
  hasDiff,
}
